import * as React from "react";
import { useParams } from "react-router-dom";
import { Document, Page } from "react-pdf";
import { Pagination } from "@jhool-io/fe-components";
import { useFetchSingleRemitDocuments } from "../../hooks/remits.queries";
import { useFetchDocument } from "../../../../hooks/queries";

export default function RemitDocument() {
    const [documentPageNumber, setDocumentPageNumber] = React.useState(1);
    const [documentNumPages, setDocumentNumPages] = React.useState<
        null | number
    >(null);
    const params = useParams();
    const remitId = params.remitId as string;
    const attachmentId = params.attachmentId as string;

    const { data } = useFetchSingleRemitDocuments(remitId);

    const remitDocInView = data?.data.find(
        (doc) => doc.remittance_attachment_id === attachmentId
    );

    const remitFile = useFetchDocument(
        remitDocInView?.url as string,
        Boolean(remitDocInView)
    );

    const fileToDisplay = () => {
        if (
            remitDocInView &&
            /^image/.test(remitDocInView?.metadata?.content_type || "")
        ) {
            return (
                <>
                    {remitFile.isLoading && (
                        <span className=" text-sm flex items-center justify-center font-medium h-12">
                            Loading document....
                        </span>
                    )}
                    {remitFile.error && (
                        <span className="text-danger text-sm flex items-center justify-center font-medium  h-12">
                            Could not load document at this time
                        </span>
                    )}
                    {remitFile.data && (
                        <div className="h-full w-full">
                            <img
                                className="w-full h-full object-contain"
                                src={`data:image/png;base64,${remitFile.data?.data}`}
                                alt={remitDocInView?.name}
                            />
                        </div>
                    )}
                </>
            );
        }

        return (
            <Document
                error={
                    <span className="text-danger text-sm flex items-center justify-center font-medium  h-12">
                        Could not load pdf at this time
                    </span>
                }
                loading={
                    <span className=" text-sm flex items-center justify-center font-medium h-12">
                        Loading pdf..
                    </span>
                }
                onLoadSuccess={({ numPages: nextNumPages }) => {
                    setDocumentNumPages(nextNumPages);
                    setDocumentPageNumber(1);
                }}
                onItemClick={({ pageNumber: itemPageNumber }) => {
                    setDocumentPageNumber(Number(itemPageNumber));
                }}
                file={`data:image/png;base64,${remitFile.data?.data}`}
            >
                <Page
                    height={550}
                    pageNumber={documentPageNumber}
                    scale={3}
                    renderAnnotationLayer={false}
                />
                {documentNumPages && documentNumPages > 1 && (
                    <Pagination
                        totalCount={documentNumPages}
                        totalPages={documentNumPages}
                        currentPage={documentPageNumber}
                        onPageChange={(page) => setDocumentPageNumber(page)}
                        pageSize={1}
                        isCentered
                    />
                )}
            </Document>
        );
    };
    return (
        <div className="page">
            <p className="font-medium text-lg text-center capitalize underline mb-12">
                {remitDocInView?.name}
            </p>
            {fileToDisplay()}
        </div>
    );
}
